import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';
export {
    default as copilotSettingsStore,
    type ImplementedCopilotFeatures,
    type CopilotSettingsStore,
    type CopilotCapableAddinInfo,
    type ElaborateFeatureCapabilities,
    type RewriteFeatureCapabilities,
    type CopilotFeatureCapabilities,
    type AddinSettings,
    type AcquisitionsSettings,
    FetchState,
} from './store/store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CopilotSettings" */ './lazyIndex'),
    { name: 'CopilotSettings' }
);

export const lazyFetchCopilotSettings: LazyAction<
    typeof lazyIndex.fetchCopilotSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.fetchCopilotSettings);
export const lazySetAddinSettingsToOcs: LazyAction<
    typeof lazyIndex.setAddinSettingsToOcs,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setAddinSettingsToOcs);

export { shouldDisableCopilot } from './utils/shouldDisableCopilot';
export { OUTLOOK_ADDIN_TITLE_ID, OUTLOOK_ADDIN_MANIFEST_ID } from './constants/copilotAddinIds';
export { LicenseType, type ChatSettings } from './services/types/serviceSettingTypes';
export { type CopilotOnboardingStatus } from './services/types/serviceSettingTypes';

export { getAddinSettingsForScenario } from './selectors/getAddinSettingsForScenario';
export { getTenantDefaultAddin } from './selectors/getTenantDefaultAddin';
export { isOldModelAddin } from './selectors/isOldModelAddin';
export { getManifestIdForAddin } from './selectors/getManifestIdForAddin';
export { getAddinIconUrl } from './selectors/getAddinIconUrl';
export { getChatSettings } from './selectors/getChatSettings';
export { getPersonalOSOnboardingStatusFromStore } from './selectors/getPersonalOSOnboardingStatusFromStore';
export { isScenarioExtensible } from './utils/isScenarioExtensible';
export { isSalesLicensePresent } from './selectors/isSalesLicensePresent';
export { default as isAIX00User } from './selectors/isAIX00User';
export { hasCopilotEnabledFeatures } from './selectors/hasCopilotEnabledFeatures';
export { default as isCopilotStoreReady } from './utils/isCopilotStoreReady';
export { default as isOptInExperienceEnabledForScenario } from './selectors/isOptInExperienceEnabledForScenario';
export { default as onOptInExperienceCompletedForScenarioMutator } from './mutators/onOptInExperienceCompletedForScenario';
export { isChatTheOnlySupportedCopilotScenario } from './selectors/isChatTheOnlySupportedCopilotScenario';

export const lazyGetAndSetCopilotCapableAddins: LazyAction<
    typeof lazyIndex.getAndSetCopilotCapableAddins,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAndSetCopilotCapableAddins);

export const lazySetAcquisitionsSettings: LazyAction<
    typeof lazyIndex.setAcquisitionsSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setAcquisitionsSettings);

export const lazyGetNativeHostDeviceId: LazyAction<
    typeof lazyIndex.getNativeHostDeviceId,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getNativeHostDeviceId);

export {
    onCopilotSettingsFetchComplete,
    type OnCopilotSettingsFetchCompleteActionMessage,
} from './actions/onCopilotSettingsFetchComplete';
